import { useState } from "react";
import { Modal, Tab, Tabs } from "react-bootstrap";
import ScheduleSettings from "./ScheduleSettings";
import CloseIcon from "~/assets/img/modal-close-icon.svg";

const Management = (props) => {
    const { t, renderAvailabilityList, setIsAddAvailability, checkAvailibilty, openManagement, closeManagement, userType, isAvailibiltyFeatureEnabled, isShiftRequestsEnabled } = props
    const [openSetting, setOpenSetting] = useState(!isAvailibiltyFeatureEnabled);
    const [openAvailibilty, setOpenAvailability] = useState(isAvailibiltyFeatureEnabled);

    const onsettingOpen = (evt) => {
        if (evt === "setting") {
            setOpenSetting(true);
            setOpenAvailability(false);
        }
        else {
            setOpenSetting(false);
            setOpenAvailability(true);
        }
    }

    return (
        <Modal show={openManagement} onHide={() => closeManagement()} className="modal right fade">
            <Modal.Body>
                <div className="scheduleModalHeader">
                    <div className="scheduleModalClosebtn" onClick={() => closeManagement()}><img src={CloseIcon} alt="close icon"></img></div>
                    <div className="mngHeadTxt">{t('Management')}</div>
                </div>
                {userType === 'admin'
                    ? (
                        <div className="d-flex justify-content-center align-items-center flex-column py-5 text-center">
                            <i className="fa fa-user-lock fa-3x text-muted mb-3"></i>
                            <p className="text-muted fs-5 fw-semibold mb-0">
                                {t('Only Project Managers can access this feature.')}
                            </p>
                        </div>
                    )
                    :
                <div className="scheduleModalBody">
                    <Tabs onSelect={onsettingOpen} className="scheduleManagementTabs">
                        <Tab eventKey="Availability" title={t('Availability')}>
                            {!isAvailibiltyFeatureEnabled ? (
                                <div className="d-flex justify-content-center align-items-center flex-column py-5 text-center">
                                    <i className="fa fa-lock fa-3x text-muted mb-3"></i>
                                    <p className="text-muted fs-5 fw-semibold mb-0">
                                        {t('Feature is disabled, please contact administrator')}
                                    </p>
                                </div>
                            ) : !!openAvailibilty &&
                                <>
                                    <div className="avblty-btns">
                                        <button className="btn-fill btn-wd btn btn-grey" onClick={() => checkAvailibilty()}> {t('Request Availability')}</button>
                                        {userType !== 'admin' && <button className="btn-fill btn-wd btn btn-primary" onClick={() => setIsAddAvailability(true)}>{t('Add Availability')} </button>}
                                    </div>
                                    {renderAvailabilityList()}
                                </>
                            }
                        </Tab>
                        <Tab eventKey="setting" title={t('Shift Requests')}>
                            {!isShiftRequestsEnabled ? (
                                <div className="d-flex justify-content-center align-items-center flex-column py-5 text-center">
                                    <i className="fa fa-lock fa-3x text-muted mb-3"></i>
                                    <p className="text-muted fs-5 fw-semibold mb-0">
                                        {t('Feature is disabled, please contact administrator')}
                                    </p>
                                </div>
                            ) : openSetting ? <ScheduleSettings /> : ''}
                        </Tab>
                    </Tabs>
                </div>}
            </Modal.Body>
        </Modal>
    )
}

export default Management;